<script>
/**
 * Type         : Dialog
 * Title        : 엑셀 업로드 결과 Dialog
 * Description  : 
 * 
 */


export default {
  name: "Excel-upload-result",
  props: {
    successCount    : Number,
    failedCount     : Number,
    successRowCount : Number,
    failedRowCount  : Number,
    successOrderCount: Number,
    successItemRowCount: Number,
    failedRows      : Array
  },
  data() {
    return {
      excelColumns : [
        { name: 'rowIndex', label: '행번호', align: 'center', field: 'rowIndex' },
        { name: 'orderId', label: 'orderId', align: 'center', field: row => row.rowData.orderId },
        { name: 'pcc', label: '통관번호', align: 'center', field: row => row.rowData.pcc },
        { name: 'error', label: '실패사유', align: 'left', field: 'error' },
      ],
    }
  },
  methods: {
  }
}
</script>


<template>

  <div class="q-pa-md">
    <div class="row q-col-gutter-md">
      <div class="col-12 col-md-3 text-center text-h5 success-cnt">성공 행: <strong>{{ successRowCount ?? successCount ?? 0 }}</strong></div>
      <div class="col-12 col-md-3 text-center text-h5 fail-cnt">실패 행: <strong>{{ failedRowCount ?? failedCount ?? 0 }}</strong></div>
      <div class="col-12 col-md-3 text-center text-h5 success-cnt">생성 주문: <strong>{{ successOrderCount || 0 }}</strong></div>
      <div class="col-12 col-md-3 text-center text-h5 success-cnt">생성 상품행: <strong>{{ successItemRowCount || 0 }}</strong></div>
    </div>
    
    <div class="q-mt-md"><strong>실패 항목:</strong></div>
    <q-table 
      style="width: 100%"
      class="my-sticky-virtscroll-table"
      virtual-scroll
      :rows-per-page-options="[0]"
      :virtual-scroll-sticky-size-start="48"
      :rows="failedRows"
      :columns="excelColumns"
      row-key="id">
    </q-table>
  </div>
            
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.success-cnt {
  color: blue
}

.fail-cnt {
  color: darkred;
}
</style>
